import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class ItemProductProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'item-products'
}
